module.exports = __webpack_public_path__ + "static/img/2.c6ec44d.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/XVC/images/2.png
// module id = MfO0
// module chunks = 4